/** Routes that must render as full pages (shareable links), not homepage split-panel iframes. */
export function isStandaloneShareableRoute(pathname: string): boolean {
  const path = pathname.split('?')[0].split('#')[0].replace(/\/$/, '') || '/';
  if (/^\/build\/quote\/[^/]+$/i.test(path)) return true;
  if (path === '/success') return true;
  return false;
}

/** True when this route is rendered inside the homepage split-panel iframe */
export function isEmbeddedSiteView(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    if (window.self !== window.top) return true;
  } catch {
    return true;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get('embed') === '1' || params.get('avatar_embed') === '1';
}

export function embedFrameSrc(pathOrUrl: string): string | null {
  try {
    const url = pathOrUrl.startsWith('http')
      ? new URL(pathOrUrl)
      : new URL(pathOrUrl, window.location.origin);
    const path = url.pathname.replace(/\/$/, '') || '/';
    if (path === '/') return null;
    url.searchParams.set('embed', '1');
    if (url.origin === window.location.origin) {
      return `${url.pathname}${url.search}${url.hash}`;
    }
    return url.toString();
  } catch {
    if (pathOrUrl === '/' || pathOrUrl === '') return null;
    const join = pathOrUrl.includes('?') ? '&' : '?';
    return `${pathOrUrl}${join}embed=1`;
  }
}

/** @deprecated alias — use embedFrameSrc */
export function withEmbedQuery(pathOrUrl: string): string | null {
  return embedFrameSrc(pathOrUrl);
}

export function markEmbeddedSiteView(): void {
  if (!isEmbeddedSiteView()) return;
  document.documentElement.setAttribute('data-avatar-embed', '1');
}

/** Hard stop for Manifest avatar sessions on the homepage embed */
export const AVATAR_SESSION_LIMIT_MS = 7 * 60 * 1000;

export const AVATAR_SESSION_LIMIT_MINUTES = 7;

export function requestManifestAvatarHangup(iframe: HTMLIFrameElement | null): void {
  if (!iframe?.contentWindow) return;
  const origins = ['https://concierge.rolemodel.ai', 'https://avatars.manifestanything.ai'];
  const payloads: Record<string, unknown>[] = [
    { type: 'manifest-avatar-hang-up' },
    { type: 'manifest-avatar-end-session' },
    { type: 'manifest-avatar-end-call' },
    { source: 'rolemodel-host', action: 'end_session' },
  ];
  for (const origin of origins) {
    for (const payload of payloads) {
      try {
        iframe.contentWindow.postMessage(payload, origin);
      } catch {
        /* cross-origin postMessage may fail if iframe already torn down */
      }
    }
  }
  try {
    iframe.src = 'about:blank';
  } catch {
    /* ignore */
  }
}
